"use client";
import { ClinicRow } from "../../types/Clinic";

/**
 * Shown instead of the booking flow when the clinic's subscription lapsed
 * (paused/canceled) — patients are pointed to the phone instead.
 */
export default function BookingDisabledNotice({
  clinic,
}: {
  clinic: ClinicRow;
}) {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#FAF8F5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 480,
          width: "100%",
          background: "#fff",
          border: "1px solid #E1E1E1",
          borderRadius: 16,
          padding: "40px 32px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontWeight: 800,
            fontSize: 22,
            color: "#2D3436",
            marginBottom: 12,
          }}
        >
          {clinic.name}
        </div>
        <p
          style={{
            color: "#636E72",
            fontSize: 16,
            lineHeight: 1.6,
            margin: "0 0 8px 0",
          }}
        >
          Online objednávanie momentálne nie je dostupné.
        </p>
        <p style={{ color: "#636E72", fontSize: 16, lineHeight: 1.6, margin: 0 }}>
          Pre objednanie termínu kontaktujte prosím ambulanciu
          {clinic.phone_number ? (
            <>
              {" "}
              telefonicky na čísle{" "}
              <a
                href={`tel:${clinic.phone_number}`}
                style={{
                  color: "#5B9BD5",
                  fontWeight: 700,
                  textDecoration: "none",
                }}
              >
                {clinic.phone_number}
              </a>
              .
            </>
          ) : (
            " telefonicky."
          )}
        </p>
      </div>
    </div>
  );
}
